import Bugsnag from '@bugsnag/js';
// @flow
import React from 'react';
import { get } from 'lodash';
import CrashScreen from './CrashScreen';
import { errorMessage } from '../../../helpers/appRecovery';

type Props = {
  children: any;
}

type State = {
  // Not `error`: anything can be thrown, also null or undefined
  hasError: boolean;
  error: any;
};

class ErrorBoundaryView extends React.Component<Props, State> {
  static getDerivedStateFromError(error: any) {
    return { hasError: true, error };
  }

  constructor(props: any) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
    };
  }

  componentDidCatch(error: any, info: ?{ componentStack?: string }) {
    if (this.shouldFilterErrorByMessage(error)) return;

    const debug = {
      userId: get(window, ['debugInfo', 'userId']) || '?',
      clinicId: get(window, ['debugInfo', 'clinicId']) || '?',
    };

    const e = new Error(`UserID: ${debug.userId} | ClinicID: ${debug.clinicId} | Message: ${errorMessage(error)}`);
    e.stack = get(error, 'stack', e.stack);
    e.name = get(error, 'name', 'Error');

    Bugsnag.notify(e, (event) => {
      event.addMetadata('react', { componentStack: get(info, 'componentStack', '') });
    });
  }

  render() {
    const { hasError, error } = this.state;
    if (hasError && !this.shouldFilterErrorByMessage(error)) {
      return <CrashScreen message={errorMessage(error)} />;
    }

    return this.props.children;
  }

  shouldFilterErrorByMessage(error: any) {
    return /MdHub is not defined/gi.test(errorMessage(error));
  }
}

export default ErrorBoundaryView;
